export const Home = () => {
  return (
    <h1 className="title">Home Page</h1>
  );
};
